// ** Modules
import React from 'react';
import { useRouter } from 'next/router';

// ** Apollo
import { initializeApollo } from '@/lib/apollo-client';
import { discoveryPagesQuery } from '@/lib/utils/pageDataUtils';

// ** Utils
import { buildPathFromRelationLink } from '@/utils/ui/navigationUtils';

export const useUserBasePath = () => {
	const { locale } = useRouter();
	const [userBasePath, setUserBasePath] = React.useState<string | null>(null);

	React.useEffect(() => {
		const fetchPath = async () => {
			try {
				const client = initializeApollo({ host: window.location.host });

				const { data } = await client.query({
					query: discoveryPagesQuery,
					variables: {
						locale,
						filters: { isUserLandingPage: { eq: true } }
					},
					fetchPolicy: 'cache-first'
				});

				const userLanding = data?.pages?.find((page) => page?.isUserLandingPage === true);
				if (userLanding) {
					const cleanedPath = buildPathFromRelationLink(userLanding).replace(/\/$/, '');
					setUserBasePath(cleanedPath);
				}
			} catch (error) {
				console.error('❌ Failed to fetch user landing page dynamically:', error);
			}
		};

		fetchPath();
	}, [locale]);

	return userBasePath;
};
